<template lang="html">
  <div class="bbs">
      <keep-alive>
        <router-view/>
      </keep-alive>
    <!-- <Notice v-if="!isAgree" @confirm="confirm" /> -->
    <AnimationModel v-if="showCreateBox" v-model="showCreateBox" height="calc(100% - 50px)">
      <template v-slot:content>
        <CreateBox @click.native="showCreateBox = false"/>
      </template>
    </AnimationModel>
    <TabBar @create="judgeNickName"/>
    <SetNickName :show="showSetNickName" @close="showSetNickName = false"/>
  </div>
</template>

<script>
import TabBar from '../../components/TabBar.vue'
import AnimationModel from '../../components/AnimationModel'
import CreateBox from '../../components/createBox'
// import Notice from '../../components/Notice'
import { set, get as getUser } from '../../utils/token'
import { put } from '../../utils/request'
import AuthMixins from '../../minixs/auth'
export default {
  mixins: [AuthMixins],
  components: {
    TabBar,
    // Notice,
    AnimationModel,
    CreateBox
  },
  created () {
    const user = getUser('user')
    if (user) {
      this.isAgree = user.isAgree
    }
  },
  data () {
    return {
      showCreateBox: false,
      isAgree: false
    }
  },
  methods: {
    judgeNickName () {
      const flag = this.judgeUserNickName()
      if (flag) {
        return
      }
      this.showCreateBox = true
    },
    close () {
      this.showCreateBox = false
    },
    confirm () {
      const user = getUser('user')
      const promsie = put({
        url: '/user/agree',
        data: {
          userId: user.id,
          isAgree: true
        }
      })
      promsie.then(res => {
        const { data: { code } } = res
        if (Object.is(code, 200)) {
          user.isAgree = true
          this.isAgree = true
          set('user', user)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bigVideoPlace {
  // margin-top: 50%;
}
.bbs {
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>
